import { SystemDescriptions } from "src/common/descriptions";
import { ServiceContract } from "src/common/models/contract";
import { formatToCurrency, formatToDisplayDate, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.SERVICE_CONTRACTS
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    CUSTOMER = 'customerName',
    TOTAL = 'total',
    PAY_DATE = 'payDate',
    NEXT_SERVICE_DEBIT = 'nextServiceDebit',
    IS_ACTIVE = 'isActive',
    ACTIONS = 'ACTIONS',
    IS_MONTHLY = 'isMonthly',
    START_DATE = 'startDate',
    CREATED_AT = 'createdAt',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.CUSTOMER,
        dataIndex: ColumnsKeys.CUSTOMER,
        key: ColumnsKeys.CUSTOMER,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.TOTAL,
        key: ColumnsKeys.TOTAL,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.IS_MONTHLY,
        dataIndex: ColumnsKeys.IS_MONTHLY,
        key: ColumnsKeys.IS_MONTHLY,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? "Si" : "No"
    },
    {
        title: descriptions.TABLE_COLUMNS.START_DATE,
        dataIndex: ColumnsKeys.START_DATE,
        key: ColumnsKeys.START_DATE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToDisplayDate(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.CREATED_AT,
        dataIndex: ColumnsKeys.CREATED_AT,
        key: ColumnsKeys.CREATED_AT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value ? formatToDisplayDatetime(value) : "--",
    },
    {
        title: descriptions.TABLE_COLUMNS.PAY_DATE,
        dataIndex: ColumnsKeys.PAY_DATE,
        key: ColumnsKeys.PAY_DATE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ServiceContract) => {
            return record.isMonthly
                ? value || "NA"
                : "--"
        }
    },
    {
        title: descriptions.TABLE_COLUMNS.NEXT_SERVICE_DEBIT,
        dataIndex: ColumnsKeys.NEXT_SERVICE_DEBIT,
        key: ColumnsKeys.NEXT_SERVICE_DEBIT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ServiceContract) => {
            if (!record.isActive) {
                return "--"
            }

            return value ? formatToDisplayDate(value) : ""
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.IS_ACTIVE,
        key: ColumnsKeys.IS_ACTIVE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? commonDescriptions.ACTIVE_STATUS : commonDescriptions.INACTIVE_STATUS
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.NO]: SummaryType.COUNT,
    [ColumnsKeys.TOTAL]: SummaryType.SUM,
}
